import { j as s } from "../../../../node_modules/react/jsx-runtime.js";
import { memo as x } from "react";
import o from "../../Containers/Containers.js";
import { Typography as i } from "../../Typography/Typography.js";
import d from "../../Icon/Icon.js";
import e from "../styles.module.scss.js";
import { clsx as a } from "../../../../node_modules/clsx/dist/clsx.m.js";
const p = ({ comment: r, isLong: l, timeWidth: t }) => /* @__PURE__ */ s.jsxs(
  "div",
  {
    className: "flex flex-col gap-050 pt-100",
    style: { "--long-width": `${t + 34}px` },
    children: [
      /* @__PURE__ */ s.jsx(
        o,
        {
          color: "white",
          border: !0,
          borderRadius: "sm",
          className: a("p-[12px]", e.commentCard, {
            [e.long]: l,
            [e.short]: !l
          }),
          children: /* @__PURE__ */ s.jsxs("div", { className: "flex justify-between items-center gap-100", children: [
            /* @__PURE__ */ s.jsxs("div", { className: "flex items-start gap-100", children: [
              /* @__PURE__ */ s.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ s.jsx(
                d,
                {
                  name: "message-circle-01",
                  ...r == null ? void 0 : r.iconProps,
                  size: "sm",
                  className: "text-color-fg-brand-default mt-[3px]"
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                i,
                {
                  text: r == null ? void 0 : r.text,
                  variant: "body-new/regular",
                  textColor: "color/fg/bold",
                  className: a({
                    "line-through": r == null ? void 0 : r.stroke
                  })
                }
              )
            ] }),
            (r == null ? void 0 : r.trailingAction) && /* @__PURE__ */ s.jsx("div", { children: r.trailingAction })
          ] })
        }
      ),
      (r == null ? void 0 : r.helperText) && /* @__PURE__ */ s.jsx(
        i,
        {
          text: r.helperText,
          variant: "body-new/regular",
          textColor: "color/fg/lighter"
        }
      )
    ]
  }
), y = x(p);
export {
  y as default
};
//# sourceMappingURL=Comment.js.map
